import { makeStyles } from '@material-ui/core';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaper: {
    minHeight: '95.96vh',
    minWidth: '97.51vw',
    borderRadius: 'unset',
    background: themeColor.modalBackground,
    overflowY: 'hidden',
  },
  dialogPaperEdge: {
    maxWidth: 'none !important',
    minHeight: 'auto !important',
    minWidth: 'auto !important',
    borderRadius: 'unset',
    background: themeColor.modalBackground,
    overflowY: 'hidden',
  },
  titleItem: {
    height: '14.71vh',
    color: '#1A2D38',
  },
  titleContainer: {
    height: '7.29vh',
    backgroundColor: themeColor.white,
    border: `1px solid ${themeColor.borderGray}`,
    borderRadius: '2px',
    alignContent: 'center',
    color: '#1A2D38',
  },
  errorContainer: {
    paddingTop: '1vh',
    height: 0,
    paddingBottom: '2vh',
  },
  errorMessage: {
    color: '#1A2D38',
    fontWeight: 500,
  },
  erroricon: {
    display: 'inline-block',
    height: '2.8vh',
    width: '2.3vw',
    color: themeColor.alert,
  },
  formError: {
    height: '4vh',
  },
  contentTitle: {
    height: '3.12vh',
    fontSize: rem(1.25),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.25px',
    color: themeColor.modalTitle,
    paddingLeft: '2.26vw',
  },
  searchTitle: {
    height: '4.94vh',
    fontSize: vh(2.34),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.24px',
    color: themeColor.itemInfoText,
  },
  searchContainer: {
    height: '33.33vh',
    alignContent: 'center',
    paddingLeft: '1.53vw',
  },
  bottomContainer: {
    marginTop: '1vh',
    marginBottom: '3vh',
  },
  searchTextItem: {
    height: '7.45vh',
  },
  inputtextItem: {
    height: 72,
    margin: 10,
    '& label': {
      fontWeight: '400',
      fontSize: '16px',
      height: '27px',
    },
  },
  inputTextField: {
    width: 450,
    margin: 10,
    textIndent: '1.2vh',
    '& label:not(.Mui-error):not(.Mui-disabled)': {
      '&.MuiFormLabel-filled': {
        color: theme.palette.secondary.main,
      },
      '&.Mui-focused': {
        color: theme.palette.secondary.main,
      },
    },

    '& > div.MuiInput-underline': {
      '&:before': {
        borderBottom: `0.398406374501992vh solid ${themeColor.borderGray}`,
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `0.11614401858304298vh solid ${themeColor.borderGray}`,
      },
      '&:after': {
        borderBottom: `0.398406374501992vh solid ${theme.palette.secondary.main}`,
      },
    },
  },
  inputTextFieldError: {
    width: 450,
    margin: 10,
    textIndent: '1.2vh',
    '& label:not(.Mui-error):not(.Mui-disabled)': {
      '&.MuiFormLabel-filled': {
        color: themeColor.alert,
      },
      '&.Mui-focused': {
        color: themeColor.alert,
      },
    },

    '& > div.MuiInput-underline': {
      '&:before': {
        borderBottom: `0.398406374501992vh solid ${themeColor.alert}`,
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `0.11614401858304298vh solid ${themeColor.alert}`,
      },
      '&:after': {
        borderBottom: `0.398406374501992vh solid ${themeColor.alert}`,
      },
    },
  },
  inputText: {
    textIndent: '1vh',
  },
  buttonContainer: {
    margin: 10,
  },
  closeButton: {
    width: 216,
  },
  approveButton: {
    width: 216,
  },
  subMessage: {
    display: 'inline-block',
    marginTop: '1vh',
  },
  subMessageCommand: {
    color: '#1A2D38',
    display: 'inline-block',
  },
  showPasswordIcon: {
    color: themeColor.alert,
  },
}));
